/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * @param {number} max - The maximum value
 * @param {number} min - The minimum value
 * @returns {number} - The random integer
 */
export function getRandomInt(max, min = 0) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
